export default "__VITE_ASSET__3352b2b2__"